export const OverridesCookieName = 'request-context-overrides';
export const encodeOverrides = (overrides) => {
    return btoa(JSON.stringify(overrides));
};
export const decodeOverrides = (encoded) => {
    try {
        return JSON.parse(atob(encoded));
    }
    catch (e) {
        return {};
    }
};
//# sourceMappingURL=overrides.js.map